import { convertToCommaString } from "../../helpers/Converter"
import "../../styles/PlayerHoldingItem.css"
export const PerPlayerStockItem = ({ company, holdings, size }) => {
    if (holdings === 0) {
        return <div></div>
    }
    return (
        <div>
            <div style={{ margin: size==="lg"?"14px":"10px" }} onClick={() => { window.location.href = "/company/" + company }}>
                <div className={`player-holding-item-container-${size}`}>
                    <img className={`player-holding-item-image-${size}`} src={`${process.env.REACT_APP_SERVER_URL}/image/${company}.png`} alt=""></img>
                    {<div className={`player-holding-item-details-${size}`}>
                        {size === "lg" && <p className="player-holding-item-company">{company.toUpperCase()}</p>}
                        {<p style={{ marginTop: size === "lg" ? "-10px" : "5px" }}>{`${convertToCommaString(1000 * holdings)} ${size === "lg" ? " Shares" : ""}`}</p>}
                    </div>}
                </div>
            </div>
        </div>
    )
}